/* eslint-disable react/prop-types */

function PaxCardGroup1(props) {
  const { fillColor } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="720" height="1280" viewBox="0 0 720 1280">
      <defs>
        <clipPath id="clipPath">
          <rect
            id="Rectangle_183"
            data-name="Rectangle 183"
            width="720"
            height="1280"
            fill="#fff"
            stroke="#707070"
            strokeWidth="1"
          />
        </clipPath>
        <filter
          id="Path_3233"
          x="238.457"
          y="421.624"
          width="655.819"
          height="786.481"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="15" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="7.5" result="blur" />
          <feFlood floodColor="#161615" floodOpacity="0.4" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="Path_3289"
          x="182.3"
          y="372.512"
          width="578.144"
          height="754.286"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="15" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="7.5" result="blur-2" />
          <feFlood floodColor="#161615" floodOpacity="0.4" />
          <feComposite operator="in" in2="blur-2" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="Path_3345"
          x="-174.276"
          y="421.624"
          width="655.819"
          height="786.481"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="15" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="7.5" result="blur-3" />
          <feFlood floodColor="#161615" floodOpacity="0.4" />
          <feComposite operator="in" in2="blur-3" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="Path_3401"
          x="-40.444"
          y="372.512"
          width="578.144"
          height="754.286"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="15" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="7.5" result="blur-4" />
          <feFlood floodColor="#161615" floodOpacity="0.4" />
          <feComposite operator="in" in2="blur-4" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="Path_3457"
          x="94.833"
          y="329.8"
          width="530.334"
          height="770.333"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="15" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="7.5" result="blur-5" />
          <feFlood floodColor="#161615" floodOpacity="0.4" />
          <feComposite operator="in" in2="blur-5" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Mask_Group_1" data-name="Mask Group 1" clipPath="url(#clipPath)">
        <g id="Graphics">
          <g id="Group_296" data-name="Group 296">
            <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#Path_3233)">
              <path
                id="Path_3233-2"
                data-name="Path 3233"
                d="M868.569,616.529c10.367-28.483-4.541-60.3-42.675-70.406L514.026,432.613c-19.042-10.706-50.914,4.086-61.281,32.569L264.254,983.057a55.375,55.375,0,0,0,33.129,70.706l311.867,113.51a55.375,55.375,0,0,0,70.827-32.869Z"
                fill="#fff"
              />
            </g>
            <g id="Group_292" data-name="Group 292">
              <path
                id="Path_3234"
                data-name="Path 3234"
                d="M386.677,1017.37l.029.063-.063.029Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3235"
                data-name="Path 3235"
                d="M429.4,899.981h0l.029.063-.063.029Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3236"
                data-name="Path 3236"
                d="M416.254,936.107l.03.063-.063.03Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3237"
                data-name="Path 3237"
                d="M373.528,1053.5l.03.063-.063.03Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3238"
                data-name="Path 3238"
                d="M472.129,782.591h0l.029.063-.063.029Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3239"
                data-name="Path 3239"
                d="M458.981,818.717l.03.063-.063.03Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3240"
                data-name="Path 3240"
                d="M514.856,665.2h0l.029.064-.063.029Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3241"
                data-name="Path 3241"
                d="M501.707,701.328l.03.063-.063.03Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3242"
                data-name="Path 3242"
                d="M362.88,809.121l4.969-13.652,82.083-38.1L411.55,675.4l4.961-13.631,47.13,100.589Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3243"
                data-name="Path 3243"
                d="M372.828,781.788l4.961-13.631L422.527,747.4,401.6,702.735l4.972-13.66,29.656,63.307Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3244"
                data-name="Path 3244"
                d="M382.759,754.5l4.978-13.676,7.356-3.419-3.431-7.364,4.971-13.658,12.185,26.017Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3245"
                data-name="Path 3245"
                d="M477.365,767.356,357.9,822.8l-1.044,2.87,55.886,119.239,121.381-56.331.015-.007-56.774-121.21h0Zm-19.886,54.639-4.371-9.329,9.34-4.323,8.733,18.64L443.158,840,425.7,802.691,472.4,781.009,520.438,883.58l-46.695,21.656-17.48-37.266,28.033-13,8.736,18.633-9.355,4.342-4.347-9.329-9.357,4.342,8.743,18.617,28.018-12.985-17.466-37.279L405.223,880.3l17.459,37.3,28.006-12.99-8.71-18.665-9.35,4.329L437,899.627l-9.348,4.32L418.9,885.278l28.044-12.985L464.412,909.6l-46.7,21.647L369.672,828.705l46.677-21.68,17.465,37.287-18.658,8.7-9.337,4.315-8.763-18.651,9.352-4.334,4.379,9.332,9.346-4.337-4.38-9.307-4.373-9.348-28.027,13.007,13.117,27.958,4.379,9.332,84.042-39-17.474-37.282L439.4,807.678l8.726,18.662Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3246"
                data-name="Path 3246"
                d="M298.258,986.669l4.969-13.652,82.083-38.1-38.382-81.969,4.961-13.631,47.13,100.589Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3247"
                data-name="Path 3247"
                d="M308.206,959.336l4.961-13.631L357.9,924.944l-20.926-44.66,4.972-13.66,29.656,63.308Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3248"
                data-name="Path 3248"
                d="M318.137,932.051l4.977-13.674,7.356-3.419-3.431-7.364,4.971-13.658,12.185,26.017Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3249"
                data-name="Path 3249"
                d="M641.827,827.227,593.778,724.679,491.054,772.351,539.1,874.9Zm-53.01-88.917,39.3,83.927-84.046,39.01-39.315-83.91Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3250"
                data-name="Path 3250"
                d="M614.414,817.249,583.84,751.983l-65.381,30.342,30.592,65.24Zm-35.546-51.606,21.843,46.62-46.7,21.672-21.85-46.623Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3251"
                data-name="Path 3251"
                d="M587,807.272l-13.1-27.977L545.872,792.3l13.109,27.98ZM568.93,792.948l4.347,9.329-9.319,4.33L559.6,797.3Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3252"
                data-name="Path 3252"
                d="M346.758,998.226l4.374,9.346,4.379,9.308-9.346,4.338-4.378-9.333-9.353,4.335L341,1034.448l-13.717-4.993-8.55-18.223Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3253"
                data-name="Path 3253"
                d="M442.112,1056.139l-18.263,8.464-14.327-5.215-4.171-8.882,9.356-4.341,4.347,9.33,9.355-4.343-8.736-18.633-28.033,13,4.165,8.879-26.767-9.742,55.607-25.793Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3254"
                data-name="Path 3254"
                d="M469.518,1066.115l-.015.007-18.234,8.461-13.709-4.989,18.256-8.467-48.041-102.57-46.7,21.681,17.456,37.309,28.023-13.016-8.733-18.641-9.34,4.323,4.371,9.33-9.348,4.345-8.726-18.662L402.8,972.239l17.474,37.282-64.948,30.14-13.7-4.986,8.914-4.119,18.658-8.7-17.465-37.287-46.677,21.68,8.535,18.217-4.892-1.78a22.412,22.412,0,0,1-14.365-22.832l118.416-54.953Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3255"
                data-name="Path 3255"
                d="M590.929,1009.771l119.353-55.389,1.088-2.989L655.551,832.224h0L534.14,888.567l-.015.007Zm19.884-54.632,4.371,9.355-9.348,4.32-8.747-18.671,28.044-12.983L642.6,974.471l-46.7,21.647L547.857,893.572l46.677-21.68L612,909.179l-18.657,8.7L584,922.19l-8.763-18.651,9.353-4.335,4.379,9.333,9.346-4.337-4.379-9.307-4.374-9.348-28.027,13.007,13.117,27.958,4.379,9.332,84.042-39L645.6,859.557,617.59,872.545l8.725,18.662,9.349-4.344-4.372-9.33,9.341-4.323,8.734,18.64-28.023,13.016-17.456-37.308,46.694-21.682,48.04,102.57L651.928,970.1l-17.479-37.267,28.032-13,8.736,18.634-9.356,4.342-4.347-9.33-9.356,4.342,8.742,18.618,28.02-12.985L667.453,906.18l-84.044,38.984,17.458,37.3,28.005-12.989-8.709-18.664Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3256"
                data-name="Path 3256"
                d="M577.2,1004.775,529.156,902.226,426.432,949.9l48.048,102.549ZM524.2,915.857l39.3,83.928-84.046,39.009-39.315-83.909Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3257"
                data-name="Path 3257"
                d="M549.792,994.8l-30.574-65.266-65.381,30.342,30.592,65.24ZM514.246,943.19l21.844,46.62-46.7,21.672L467.54,964.86Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3258"
                data-name="Path 3258"
                d="M522.379,984.82l-13.1-27.977L481.249,969.85l13.11,27.98ZM504.308,970.5l4.347,9.329-9.319,4.33-4.361-9.309Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3259"
                data-name="Path 3259"
                d="M769.934,790.488l-4.961,13.631L682.941,842.2l38.366,81.884-4.969,13.652-47.1-100.523Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3260"
                data-name="Path 3260"
                d="M760,817.792l-4.971,13.659-44.679,20.728,20.9,44.6-4.961,13.631-29.643-63.216Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3261"
                data-name="Path 3261"
                d="M750.056,845.1l-4.971,13.658-7.3,3.4,3.414,7.284-4.977,13.675-12.161-25.955Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3262"
                data-name="Path 3262"
                d="M469.518,1066.115l121.411-56.344,55.337,118.14a22.415,22.415,0,0,1-25.706,8.289l-4.8-1.746,18.239-8.46-48.04-102.571L539.266,1045.1l17.456,37.309,28.022-13.016-8.733-18.641-9.34,4.323,4.371,9.33-9.349,4.344-8.725-18.661L580.98,1037.1l17.474,37.282-64.932,30.134-13.7-4.987,8.9-4.111,18.657-8.7-17.464-37.287-46.677,21.68,8.527,18.2-13.727-5-8.532-18.2Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3263"
                data-name="Path 3263"
                d="M620.3,1121.007l-18.248,8.456-14.35-5.223-4.163-8.866,9.356-4.342,4.347,9.33,9.356-4.342-8.737-18.633-28.032,13,4.158,8.864-26.745-9.734,55.591-25.787Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3264"
                data-name="Path 3264"
                d="M524.943,1063.093l4.374,9.347,4.38,9.309-9.346,4.337-4.379-9.332-9.353,4.334,8.558,18.213-13.717-4.993-8.542-18.207Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3265"
                data-name="Path 3265"
                d="M427.5,631.574l4.969-13.652,82.083-38.1-38.382-81.969,4.961-13.631,47.13,100.59Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3266"
                data-name="Path 3266"
                d="M437.45,604.242l4.961-13.631,44.738-20.762-20.926-44.66,4.972-13.66,29.656,63.308Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3267"
                data-name="Path 3267"
                d="M447.381,576.957l4.977-13.675,7.356-3.418-3.431-7.364,4.971-13.658,12.185,26.018Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3268"
                data-name="Path 3268"
                d="M541.987,589.81,422.524,645.25l-1.044,2.869,55.885,119.237h0l121.381-56.33.015-.007L541.988,589.81h0ZM522.1,644.449l-4.371-9.33,9.34-4.323,8.733,18.64L507.78,662.452l-17.456-37.308,46.695-21.682L585.06,706.033l-46.7,21.656-17.48-37.266,28.033-13,8.736,18.633L548.3,700.4l-4.347-9.33-9.357,4.342,8.743,18.617,28.018-12.985L553.89,663.766l-84.045,38.985,17.459,37.3,28.005-12.99L506.6,708.4l-9.35,4.327,4.371,9.355-9.348,4.32-8.747-18.67,28.044-12.984,17.464,37.311-46.7,21.647L434.294,651.159l46.677-21.68,17.465,37.286-18.658,8.7-9.338,4.315-8.763-18.65,9.353-4.335,4.379,9.332,9.346-4.337-4.38-9.308L476,643.132l-28.027,13.006,13.117,27.957,4.379,9.333,84.042-39-17.474-37.282-28.012,12.987,8.725,18.663Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3269"
                data-name="Path 3269"
                d="M477.365,767.357h0Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3270"
                data-name="Path 3270"
                d="M706.448,649.68,658.4,547.132,555.676,594.8l48.048,102.548Zm-53.009-88.918,39.3,83.928L608.693,683.7l-39.315-83.91Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3271"
                data-name="Path 3271"
                d="M679.036,639.7l-30.575-65.266-65.38,30.341,30.592,65.24ZM643.49,588.1l21.843,46.62-46.7,21.671-21.85-46.622Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3272"
                data-name="Path 3272"
                d="M651.623,629.725l-13.1-27.976-28.028,13.006,13.11,27.981ZM633.551,615.4l4.348,9.329-9.319,4.331-4.361-9.31Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3273"
                data-name="Path 3273"
                d="M655.551,832.224,774.9,776.835l1.088-2.988-55.818-119.17h0L598.762,711.02l-.015.007,56.8,121.2h0Zm19.884-54.632,4.37,9.355-9.347,4.32L661.71,772.6l28.044-12.984,17.464,37.311-46.7,21.647L612.479,716.025l46.677-21.68,17.464,37.287-18.657,8.7-9.338,4.316-8.763-18.651,9.353-4.335,4.379,9.334,9.346-4.338-4.38-9.308L654.187,708,626.16,721.006l13.117,27.956,4.379,9.333,84.042-39-17.474-37.281L682.212,695l8.725,18.662,9.349-4.345-4.372-9.329,9.341-4.323,8.734,18.64-28.023,13.016L668.51,690.01,715.2,668.329,763.244,770.9,716.55,792.557l-17.479-37.268,28.031-13,8.737,18.633-9.356,4.341-4.347-9.329-9.356,4.342,8.742,18.618,28.02-12.985-17.467-37.279L648.03,767.618l17.459,37.3,28-12.99-8.708-18.665Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3274"
                data-name="Path 3274"
                d="M655.551,832.224h0Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3275"
                data-name="Path 3275"
                d="M834.556,612.94,829.6,626.571l-82.032,38.087,38.367,81.884-4.969,13.652-47.1-100.523Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3276"
                data-name="Path 3276"
                d="M824.618,640.245,819.647,653.9l-44.679,20.728,20.9,44.6-4.961,13.631-29.643-63.216Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3277"
                data-name="Path 3277"
                d="M814.678,667.557l-4.971,13.658-7.3,3.4,3.414,7.284-4.977,13.675-12.161-25.955Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3278"
                data-name="Path 3278"
                d="M512.263,463.385l4.861,1.77-18.209,8.457,48.042,102.545,46.7-21.647L576.192,517.2l-28.045,12.984,8.748,18.67,9.348-4.321-4.371-9.353,9.35-4.328,8.709,18.664-28.005,12.99-17.459-37.3,64.913-30.111,13.715,4.992-27.588,12.79,17.48,37.267,46.7-21.656L641.165,510.3l13.7,4.986,8.517,18.185-.014.007L541.988,589.81h0L486.6,471.625A22.411,22.411,0,0,1,512.263,463.385Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3279"
                data-name="Path 3279"
                d="M525.714,506.548,512.6,478.591l18.217-8.454,14.392,5.238,4.17,8.864-9.346,4.337-4.378-9.333-9.353,4.335,8.763,18.651,9.338-4.316,18.658-8.7-4.148-8.855,26.743,9.734-55.56,25.784Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3280"
                data-name="Path 3280"
                d="M607.96,536.483l-8.742-18.618,9.356-4.341,4.347,9.329,9.355-4.342-8.527-18.189,13.709,4.99,8.521,18.185Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3281"
                data-name="Path 3281"
                d="M541.987,589.81h0Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3282"
                data-name="Path 3282"
                d="M786.144,601.35,777.4,582.732l9.356-4.342,4.347,9.329,9.356-4.342-8.535-18.2,13.71,4.99,8.528,18.2Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3283"
                data-name="Path 3283"
                d="M720.173,654.676h0l-56.8-121.2.014-.007,18.218-8.454,13.723,4.995L677.1,538.479l48.042,102.545,46.7-21.647-17.464-37.311L726.332,595.05l8.747,18.67,9.348-4.32-4.37-9.355,9.35-4.327,8.708,18.664-28.005,12.99-17.458-37.3,64.929-30.118,13.713,4.991-27.6,12.8,17.48,37.268,46.694-21.658-8.524-18.2,4.788,1.743a22.412,22.412,0,0,1,14.363,22.871l-118.32,54.91Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3284"
                data-name="Path 3284"
                d="M703.9,571.415l-13.117-27.957L709.014,535l14.37,5.23,4.178,8.879-9.346,4.337-4.379-9.333-9.353,4.335,8.763,18.651,9.338-4.316,18.657-8.7-4.155-8.871,26.767,9.742-55.576,25.791Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3285"
                data-name="Path 3285"
                d="M720.173,654.677h0Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3286"
                data-name="Path 3286"
                d="M705.313,968.035l-4.961,13.631-82.032,38.087,38.366,81.884-4.969,13.652-47.1-100.523Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3287"
                data-name="Path 3287"
                d="M695.374,995.34,690.4,1009l-44.678,20.728,20.9,44.6-4.961,13.631-29.643-63.216Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3288"
                data-name="Path 3288"
                d="M685.434,1022.652l-4.971,13.658-7.3,3.4,3.414,7.284-4.977,13.675-12.161-25.955Z"
                fill={fillColor || '#8ea5ab'}
              />
            </g>
            <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#Path_3289)">
              <path
                id="Path_3289-2"
                data-name="Path 3289"
                d="M737.121,501.048c5.263-29.85-14.944-58.6-54.253-61.925l-326.84-57.631c-20.612-7.236-49.431,12.865-54.7,42.715l-95.7,542.739a55.376,55.376,0,0,0,44.9,63.879l326.841,57.63a55.374,55.374,0,0,0,64.043-44.668Z"
                fill="#fff"
              />
            </g>
            <g id="Group_293" data-name="Group 293">
              <path
                id="Path_3290"
                data-name="Path 3290"
                d="M332.155,979.48l.04.057-.057.04Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3291"
                data-name="Path 3291"
                d="M353.848,856.454h0l.04.057-.057.04Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3292"
                data-name="Path 3292"
                d="M347.172,894.314l.04.057-.057.04Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3293"
                data-name="Path 3293"
                d="M325.479,1017.34l.04.057-.057.04Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3294"
                data-name="Path 3294"
                d="M375.541,733.429h0l.04.057-.057.04Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3295"
                data-name="Path 3295"
                d="M368.865,771.289l.04.057-.057.04Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3296"
                data-name="Path 3296"
                d="M397.233,610.4h0l.04.058-.057.04Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3297"
                data-name="Path 3297"
                d="M390.558,648.263l.04.057-.057.04Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3298"
                data-name="Path 3298"
                d="M272.558,778.527l2.523-14.307,74.22-51.774-52.033-74.058,2.519-14.285,63.882,90.877Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3299"
                data-name="Path 3299"
                d="M277.609,749.881l2.519-14.285,40.453-28.215-28.363-40.348,2.524-14.315,40.2,57.2Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3300"
                data-name="Path 3300"
                d="M282.65,721.288l2.527-14.332,6.651-4.644-4.658-6.656,2.524-14.314,16.518,23.506Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3301"
                data-name="Path 3301"
                d="M378.052,717.516,270.031,792.858l-.531,3.008,75.743,107.722L455,827.036l.014-.01-76.959-109.51h0Zm-10.1,57.262-5.924-8.428,8.447-5.88,11.837,16.84-25.336,17.685-23.67-33.71,42.22-29.461,65.123,92.67L398.427,853.93l-23.686-33.665L400.092,802.6,411.93,819.43l-8.459,5.9-5.9-8.433-8.46,5.9,11.842,16.816,25.338-17.653-23.674-33.68-76,52.987,23.672,33.7,25.324-17.656L363.8,840.447l-8.457,5.887,5.929,8.452-8.456,5.879L340.955,843.8l25.363-17.657L390,859.852l-42.23,29.427-65.119-92.645,42.2-29.456,23.674,33.687-16.865,11.8-8.446,5.871-11.868-16.846L319.8,795.8l5.933,8.43,8.45-5.894-5.929-8.406-5.93-8.446-25.343,17.676,17.773,25.255,5.933,8.43,75.993-53L373,746.163,347.67,763.817,359.5,780.68Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3302"
                data-name="Path 3302"
                d="M239.748,964.6l2.523-14.308,74.22-51.774-52.033-74.059,2.519-14.285,63.881,90.877Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3303"
                data-name="Path 3303"
                d="M244.8,935.954l2.519-14.285,40.453-28.215-28.363-40.348,2.524-14.316,40.2,57.2Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3304"
                data-name="Path 3304"
                d="M249.841,907.359l2.527-14.331,6.651-4.644-4.658-6.656,2.524-14.314L273.4,890.92Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3305"
                data-name="Path 3305"
                d="M550.411,747.918l-65.126-92.646L392.4,720.058,457.525,812.7Zm-67.645-78.361,53.277,75.828-76,53.012L406.76,722.589Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3306"
                data-name="Path 3306"
                d="M521.682,742.853l-41.443-58.965L421.12,725.121l41.456,58.937ZM477.715,698.2l29.607,42.119L465.1,769.773l-29.614-42.12Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3307"
                data-name="Path 3307"
                d="M492.953,737.787l-17.761-25.276-25.343,17.676,17.769,25.279Zm-20.284-10.968,5.9,8.432-8.425,5.883-5.912-8.411Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3308"
                data-name="Path 3308"
                d="M289.519,967.558l5.93,8.445,5.929,8.406-8.451,5.895-5.933-8.431-8.458,5.893,11.6,16.464L275.76,1001.7l-11.585-16.461Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3309"
                data-name="Path 3309"
                d="M393.481,1008.033l-16.516,11.507-15.015-2.648-5.65-8.023,8.46-5.9,5.9,8.433,8.459-5.9-11.838-16.833-25.35,17.668,5.643,8.021-28.052-4.946,50.283-35.057Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3310"
                data-name="Path 3310"
                d="M422.2,1013.1l-.014.01-16.487,11.5-14.367-2.533,16.508-11.508L342.72,917.9,300.5,947.357l23.669,33.71,25.337-17.685-11.837-16.84-8.448,5.879,5.925,8.429-8.452,5.9L314.86,949.889l25.332-17.654,23.682,33.681-58.727,40.961-14.359-2.532,8.063-5.6,16.864-11.8L292.042,953.25l-42.2,29.456,11.568,16.458-5.127-.9a22.413,22.413,0,0,1-18.111-19.991l107.075-74.681Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3311"
                data-name="Path 3311"
                d="M531.985,936.527l107.921-75.272.552-3.132L564.794,750.457h0l-109.782,76.57-.014.01Zm10.1-57.254,5.929,8.453-8.456,5.878L527.7,876.736,553.06,859.08l23.677,33.712L534.508,922.22l-65.119-92.647,42.2-29.455L535.266,833.8l-16.863,11.8-8.447,5.872-11.869-16.846,8.458-5.893,5.934,8.431,8.451-5.9-5.93-8.4-5.93-8.446L483.728,832.1,501.5,857.357l5.933,8.43,75.993-53L559.743,779.1l-25.331,17.655,11.833,16.863,8.452-5.9-5.925-8.428,8.448-5.879,11.838,16.84-25.337,17.684-23.67-33.71,42.22-29.461,65.122,92.67L585.169,886.87l-23.685-33.665,25.349-17.668,11.839,16.833-8.46,5.9-5.9-8.433-8.459,5.9,11.841,16.818,25.34-17.654-23.675-33.68-76,52.986,23.67,33.7,25.324-17.655-11.817-16.868Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3312"
                data-name="Path 3312"
                d="M517.6,933.991l-65.126-92.647L359.59,906.129l65.125,92.647Zm-67.645-78.362,53.277,75.828-75.995,53.011L373.95,908.661Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3313"
                data-name="Path 3313"
                d="M488.873,928.925,447.429,869.96l-59.118,41.233,41.456,58.937ZM444.9,884.275l29.607,42.118-42.227,29.452-29.614-42.12Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3314"
                data-name="Path 3314"
                d="M460.144,923.859l-17.762-25.276-25.343,17.676,17.769,25.278Zm-20.285-10.968,5.9,8.432-8.425,5.883-5.911-8.411Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3315"
                data-name="Path 3315"
                d="M670.193,689.492l-2.519,14.285L593.5,755.529l52,73.978-2.523,14.307L579.141,753Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3316"
                data-name="Path 3316"
                d="M665.147,718.107l-2.524,14.315-40.4,28.172,28.329,40.291-2.519,14.285-40.169-57.108Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3317"
                data-name="Path 3317"
                d="M660.1,746.73l-2.524,14.314-6.6,4.62,4.627,6.581-2.527,14.332-16.483-23.449Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3318"
                data-name="Path 3318"
                d="M422.2,1013.1l109.783-76.571,75.01,106.737a22.414,22.414,0,0,1-23.875,12.627l-5.03-.887,16.493-11.5-65.121-92.671L487.242,980.3l23.669,33.711,25.337-17.684L524.41,979.482l-8.447,5.879,5.925,8.429-8.452,5.9L501.6,982.829l25.33-17.655,23.683,33.682L491.9,1039.807l-14.36-2.532,8.05-5.594,16.864-11.8L478.783,986.19l-42.2,29.456,11.559,16.444-14.387-2.537-11.564-16.445Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3319"
                data-name="Path 3319"
                d="M580.223,1040.974l-16.5,11.5-15.039-2.652-5.64-8.008,8.46-5.9,5.9,8.433,8.46-5.9-11.839-16.833-25.349,17.668,5.634,8.007-28.029-4.942,50.269-35.048Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3320"
                data-name="Path 3320"
                d="M476.26,1000.5l5.931,8.445,5.929,8.407-8.451,5.894-5.933-8.43-8.458,5.893,11.59,16.45-14.376-2.535-11.574-16.447Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3321"
                data-name="Path 3321"
                d="M305.367,592.456l2.523-14.307,74.22-51.774-52.033-74.059,2.519-14.285,63.881,90.877Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3322"
                data-name="Path 3322"
                d="M310.418,563.811l2.519-14.285L353.39,521.31l-28.363-40.348,2.524-14.316,40.2,57.2Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3323"
                data-name="Path 3323"
                d="M315.46,535.216l2.527-14.332,6.651-4.644-4.658-6.656L322.5,495.27l16.517,23.507Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3324"
                data-name="Path 3324"
                d="M410.861,531.445,302.84,606.787l-.53,3.007,75.742,107.722h0l109.754-76.551.014-.01-76.959-109.51h0Zm-10.1,57.262-5.925-8.429,8.448-5.879,11.837,16.84-25.337,17.685-23.669-33.71,42.22-29.462,65.122,92.671-42.225,29.436-23.685-33.665,25.35-17.668,11.838,16.833-8.459,5.9-5.9-8.433-8.46,5.9,11.843,16.816L459.1,635.891l-23.675-33.68-76,52.987L383.1,688.9l25.324-17.656L396.6,654.377l-8.456,5.885,5.929,8.453-8.456,5.878-11.857-16.867,25.364-17.657L422.8,673.781l-42.23,29.427-65.118-92.645,42.2-29.456,23.674,33.687L364.47,626.6l-8.446,5.871-11.869-16.846,8.458-5.892,5.933,8.43L367,612.267l-5.93-8.407-5.93-8.445-25.343,17.676,17.774,25.255,5.932,8.43,75.993-53L405.81,560.092l-25.331,17.654,11.834,16.864Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3325"
                data-name="Path 3325"
                d="M378.052,717.516h0Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3326"
                data-name="Path 3326"
                d="M583.22,561.847,518.094,469.2l-92.885,64.786,65.125,92.646Zm-67.645-78.361,53.277,75.828-75.995,53.012-53.288-75.808Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3327"
                data-name="Path 3327"
                d="M554.492,556.782l-41.444-58.965L453.93,539.05l41.455,58.937Zm-43.968-44.651,29.607,42.119L497.9,583.7l-29.614-42.12Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3328"
                data-name="Path 3328"
                d="M525.763,551.716,508,526.44l-25.343,17.676L500.427,569.4Zm-20.285-10.968,5.9,8.432-8.425,5.883-5.912-8.411Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3329"
                data-name="Path 3329"
                d="M564.794,750.457l107.921-75.273.553-3.132L597.6,564.385h0l-109.782,76.57-.014.01,76.987,109.491h0Zm10.1-57.255,5.928,8.454-8.455,5.877-11.857-16.868,25.363-17.656,23.677,33.712-42.229,29.427L502.2,643.5l42.2-29.457,23.674,33.688-16.864,11.8-8.447,5.872L530.9,648.563l8.458-5.893,5.933,8.431,8.451-5.9L547.81,636.8l-5.931-8.445-25.342,17.676,17.772,25.255,5.933,8.43,75.993-53-23.683-33.682-25.331,17.654,11.833,16.864,8.453-5.9-5.926-8.429,8.448-5.879,11.838,16.84L576.53,641.864l-23.669-33.711,42.219-29.46,65.122,92.67L617.979,700.8l-23.686-33.666,25.349-17.667L631.481,666.3l-8.459,5.9-5.9-8.433-8.46,5.9L620.5,686.484l25.339-17.653-23.675-33.68-76,52.987,23.67,33.7,25.324-17.655-11.817-16.869Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3330"
                data-name="Path 3330"
                d="M564.794,750.457h0Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3331"
                data-name="Path 3331"
                d="M703,503.42l-2.519,14.285-74.172,51.753,52,73.978-2.523,14.308-63.84-90.817Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3332"
                data-name="Path 3332"
                d="M697.956,532.036l-2.524,14.315-40.4,28.172,28.329,40.291L680.842,629.1,640.672,571.99Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3333"
                data-name="Path 3333"
                d="M692.909,560.659l-2.524,14.314-6.6,4.62,4.627,6.581L685.883,600.5,669.4,577.056Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3334"
                data-name="Path 3334"
                d="M359.635,412.1l5.1.9-16.464,11.491,65.118,92.645,42.231-29.427L431.937,454l-25.363,17.657,11.856,16.867,8.456-5.878-5.929-8.453,8.456-5.885,11.818,16.867L415.907,502.83l-23.671-33.7,58.7-40.925,14.373,2.534L440.36,448.123l23.686,33.665,42.224-29.436-11.545-16.429,14.359,2.532,11.546,16.43-.013.008L410.862,531.445h0l-75.073-106.77A22.413,22.413,0,0,1,359.635,412.1Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3335"
                data-name="Path 3335"
                d="M380.377,452.275,362.6,427.02l16.473-11.489,15.083,2.66,5.646,8-8.451,5.895-5.933-8.431-8.458,5.893L388.833,446.4l8.446-5.872,16.865-11.8-5.623-8,28.027,4.942-50.239,35.04Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3336"
                data-name="Path 3336"
                d="M466.571,467.473l-11.843-16.817,8.46-5.9,5.9,8.432,8.459-5.9-11.556-16.431,14.367,2.533,11.549,16.43Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3337"
                data-name="Path 3337"
                d="M410.861,531.445h0Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3338"
                data-name="Path 3338"
                d="M653.312,500.413,641.47,483.6l8.459-5.9,5.9,8.432,8.46-5.9-11.567-16.445,14.368,2.534,11.559,16.443Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3339"
                data-name="Path 3339"
                d="M597.6,564.384h0L520.617,454.893l.013-.008,16.473-11.49,14.382,2.536-16.477,11.5,65.118,92.645,42.23-29.427-23.678-33.712L593.315,504.6l11.857,16.867,8.455-5.878-5.928-8.453,8.457-5.886,11.817,16.869-25.324,17.655-23.67-33.7,58.712-40.935,14.372,2.534-24.96,17.4,23.685,33.667,42.224-29.438-11.555-16.442,5.018.885a22.414,22.414,0,0,1,18.117,20.029L597.6,564.385Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3340"
                data-name="Path 3340"
                d="M567.118,485.215,549.346,459.96l16.486-11.5,15.06,2.655,5.656,8.019L578.1,465.03l-5.933-8.431-8.458,5.893,11.868,16.846,8.447-5.872,16.864-11.8-5.633-8.014,28.052,4.946-50.253,35.05Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3341"
                data-name="Path 3341"
                d="M597.6,564.385h0Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3342"
                data-name="Path 3342"
                d="M637.383,875.563l-2.519,14.285L560.692,941.6l52,73.978-2.523,14.307-63.84-90.817Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3343"
                data-name="Path 3343"
                d="M632.337,904.179l-2.524,14.315-40.4,28.171,28.329,40.291-2.519,14.286-40.169-57.108Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3344"
                data-name="Path 3344"
                d="M627.29,932.8l-2.524,14.314-6.6,4.62,4.627,6.581-2.527,14.332L603.782,949.2Z"
                fill={fillColor || '#8ea5ab'}
              />
            </g>
            <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#Path_3345)">
              <path
                id="Path_3345-2"
                data-name="Path 3345"
                d="M-148.569,616.529c-10.367-28.483,4.541-60.3,42.675-70.406l311.868-113.51c19.042-10.706,50.914,4.086,61.281,32.569L455.746,983.057a55.375,55.375,0,0,1-33.129,70.706L110.75,1167.273A55.375,55.375,0,0,1,39.923,1134.4Z"
                fill="#fff"
              />
            </g>
            <g id="Group_294" data-name="Group 294">
              <path
                id="Path_3346"
                data-name="Path 3346"
                d="M333.323,1017.37l-.029.063.063.029Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3347"
                data-name="Path 3347"
                d="M290.6,899.981h0l-.029.063.063.029Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3348"
                data-name="Path 3348"
                d="M303.746,936.107l-.03.063.063.03Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3349"
                data-name="Path 3349"
                d="M346.472,1053.5l-.03.063.063.03Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3350"
                data-name="Path 3350"
                d="M247.871,782.591h0l-.029.063.063.029Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3351"
                data-name="Path 3351"
                d="M261.019,818.717l-.03.063.063.03Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3352"
                data-name="Path 3352"
                d="M205.144,665.2h0l-.029.064.063.029Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3353"
                data-name="Path 3353"
                d="M218.293,701.328l-.03.063.063.03Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3354"
                data-name="Path 3354"
                d="M357.12,809.121l-4.969-13.652-82.083-38.1L308.45,675.4l-4.961-13.631L256.359,762.36Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3355"
                data-name="Path 3355"
                d="M347.172,781.788l-4.961-13.631L297.473,747.4l20.926-44.66-4.972-13.66-29.656,63.307Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3356"
                data-name="Path 3356"
                d="M337.241,754.5l-4.978-13.676-7.356-3.419,3.431-7.364-4.971-13.658-12.185,26.017Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3357"
                data-name="Path 3357"
                d="M242.634,767.357h0L185.86,888.567l.015.007,121.381,56.331,55.886-119.239L362.1,822.8l-119.463-55.44Zm29.235,58.983,8.726-18.662-28.012-12.987-17.474,37.282,84.042,39,4.379-9.332,13.117-27.958L308.62,820.678l-4.373,9.348-4.38,9.307,9.346,4.337,4.379-9.332,9.352,4.334-8.763,18.651-9.337-4.315-18.658-8.7,17.465-37.287,46.677,21.68L302.287,931.251l-46.7-21.647,17.464-37.311L301.1,885.278l-8.747,18.669L283,899.627l4.371-9.354-9.35-4.329-8.71,18.665,28.006,12.99,17.459-37.3-84.045-38.985-17.466,37.279,28.018,12.985,8.743-18.617-9.357-4.342-4.347,9.329-9.355-4.342,8.736-18.633,28.033,13-17.48,37.266-46.7-21.656L247.6,781.009,294.3,802.691,276.842,840l-28.023-13.016,8.733-18.64,9.34,4.323-4.371,9.329Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3358"
                data-name="Path 3358"
                d="M421.742,986.669l-4.969-13.652-82.083-38.1,38.382-81.969-4.961-13.631-47.13,100.589Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3359"
                data-name="Path 3359"
                d="M411.794,959.336l-4.961-13.631L362.1,924.944l20.926-44.66-4.972-13.66-29.656,63.308Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3360"
                data-name="Path 3360"
                d="M401.863,932.051l-4.977-13.674-7.356-3.419,3.431-7.364-4.971-13.658-12.185,26.017Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3361"
                data-name="Path 3361"
                d="M180.9,874.9l48.048-102.548L126.222,724.679,78.173,827.227Zm34.346-97.562-39.315,83.91-84.046-39.01,39.3-83.927Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3362"
                data-name="Path 3362"
                d="M170.949,847.565l30.592-65.24L136.16,751.983l-30.574,65.266Zm16.889-60.253-21.85,46.623-46.7-21.672,21.843-46.62Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3363"
                data-name="Path 3363"
                d="M161.019,820.282l13.109-27.98L146.1,779.295,133,807.272ZM160.4,797.3l-4.361,9.309-9.319-4.33,4.347-9.329Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3364"
                data-name="Path 3364"
                d="M373.242,998.226l-4.374,9.346-4.379,9.308,9.346,4.338,4.378-9.333,9.353,4.335L379,1034.448l13.717-4.993,8.55-18.223Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3365"
                data-name="Path 3365"
                d="M277.888,1056.139l18.263,8.464,14.327-5.215,4.171-8.882-9.356-4.341-4.347,9.33-9.355-4.343,8.736-18.633,28.033,13-4.165,8.879,26.767-9.742-55.607-25.793Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3366"
                data-name="Path 3366"
                d="M250.482,1066.115l.015.007,18.234,8.461,13.709-4.989-18.256-8.467,48.041-102.57,46.7,21.681-17.456,37.309-28.023-13.016,8.733-18.641,9.34,4.323-4.371,9.33,9.348,4.345,8.726-18.662L317.2,972.239l-17.474,37.282,64.948,30.14,13.7-4.986-8.914-4.119-18.658-8.7,17.465-37.287,46.677,21.68-8.535,18.217,4.892-1.78a22.412,22.412,0,0,0,14.365-22.832L307.256,944.905Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3367"
                data-name="Path 3367"
                d="M185.875,888.574l-.015-.007L64.45,832.224h0L8.63,951.393l1.088,2.989,119.353,55.389ZM99.837,950.812l-8.709,18.664,28.005,12.989,17.458-37.3L52.547,906.18,35.08,943.459,63.1,956.444l8.742-18.618-9.356-4.342-4.347,9.33-9.356-4.342,8.736-18.634,28.032,13L68.072,970.1,21.378,948.446l48.04-102.57,46.694,21.682L98.656,904.866,70.633,891.85l8.734-18.64,9.341,4.323-4.372,9.33,9.349,4.344,8.725-18.662L74.4,859.557,56.924,896.84l84.042,39,4.379-9.332,13.117-27.958-28.027-13.007-4.374,9.348-4.379,9.307,9.346,4.337,4.379-9.333,9.353,4.335L136,922.19l-9.338-4.315L108,909.179l17.464-37.287,46.677,21.68L124.1,996.118,77.4,974.471,94.867,937.16l28.044,12.983-8.747,18.671-9.348-4.32,4.371-9.355Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3368"
                data-name="Path 3368"
                d="M245.52,1052.447,293.568,949.9,190.844,902.226,142.8,1004.775Zm34.346-97.562-39.315,83.909-84.046-39.009,39.3-83.928Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3369"
                data-name="Path 3369"
                d="M235.571,1025.113l30.592-65.24-65.381-30.342L170.208,994.8ZM252.46,964.86l-21.85,46.622-46.7-21.672,21.844-46.62Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3370"
                data-name="Path 3370"
                d="M225.641,997.83l13.11-27.98-28.028-13.007-13.1,27.977Zm-.616-22.984-4.361,9.309-9.319-4.33,4.347-9.329Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3371"
                data-name="Path 3371"
                d="M-49.934,790.488l4.961,13.631L37.059,842.2-1.308,924.089,3.661,937.74l47.1-100.523Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3372"
                data-name="Path 3372"
                d="M-40,817.792l4.971,13.659L9.654,852.179l-20.9,44.6,4.961,13.631,29.643-63.216Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3373"
                data-name="Path 3373"
                d="M-30.056,845.1l4.971,13.658,7.3,3.4-3.414,7.284,4.977,13.675,12.161-25.955Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3374"
                data-name="Path 3374"
                d="M250.482,1066.115l-121.411-56.344-55.337,118.14A22.415,22.415,0,0,0,99.44,1136.2l4.8-1.746L86,1125.994l48.04-102.571,46.694,21.682-17.456,37.309L135.256,1069.4l8.733-18.641,9.34,4.323-4.371,9.33,9.349,4.344,8.725-18.661L139.02,1037.1l-17.474,37.282,64.932,30.134,13.7-4.987-8.9-4.111-18.657-8.7,17.464-37.287,46.677,21.68-8.527,18.2,13.727-5,8.532-18.2Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3375"
                data-name="Path 3375"
                d="M99.7,1121.007l18.248,8.456,14.35-5.223,4.163-8.866-9.356-4.342-4.347,9.33-9.356-4.342,8.737-18.633,28.032,13-4.158,8.864,26.745-9.734-55.591-25.787Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3376"
                data-name="Path 3376"
                d="M195.057,1063.093l-4.374,9.347-4.38,9.309,9.346,4.337,4.379-9.332,9.353,4.334-8.558,18.213,13.717-4.993,8.542-18.207Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3377"
                data-name="Path 3377"
                d="M292.5,631.574l-4.969-13.652-82.083-38.1,38.382-81.969-4.961-13.631-47.13,100.59Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3378"
                data-name="Path 3378"
                d="M282.55,604.242l-4.961-13.631-44.738-20.762,20.926-44.66-4.972-13.66-29.656,63.308Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3379"
                data-name="Path 3379"
                d="M272.619,576.957l-4.977-13.675-7.356-3.418,3.431-7.364-4.971-13.658-12.185,26.018Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3380"
                data-name="Path 3380"
                d="M178.012,589.81h0L121.238,711.02l.015.007,121.381,56.33h0L298.52,648.119l-1.044-2.869L178.013,589.81Zm29.236,58.984,8.725-18.663-28.012-12.987-17.474,37.282,84.042,39,4.379-9.333,13.117-27.957L244,643.132l-4.373,9.346-4.38,9.308,9.346,4.337,4.379-9.332,9.353,4.335-8.763,18.65-9.338-4.315-18.658-8.7,17.465-37.286,46.677,21.68L237.665,753.7l-46.7-21.647,17.464-37.311,28.044,12.984-8.747,18.67-9.348-4.32,4.371-9.355L213.4,708.4l-8.709,18.664,28.005,12.99,17.459-37.3L166.11,663.766l-17.466,37.279,28.018,12.985,8.743-18.617-9.357-4.342L171.7,700.4l-9.355-4.343,8.736-18.633,28.033,13-17.48,37.266L134.94,706.033l48.041-102.571,46.695,21.682L212.22,662.452,184.2,649.436l8.733-18.64,9.34,4.323-4.371,9.33Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3381"
                data-name="Path 3381"
                d="M242.635,767.357h0Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3382"
                data-name="Path 3382"
                d="M116.276,697.352,164.324,594.8,61.6,547.132,13.552,649.68Zm34.346-97.562L111.307,683.7,27.261,644.69l39.3-83.928Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3383"
                data-name="Path 3383"
                d="M106.327,670.018l30.592-65.24-65.38-30.341L40.964,639.7Zm16.889-60.253-21.85,46.622-46.7-21.671L76.51,588.1Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3384"
                data-name="Path 3384"
                d="M96.4,642.736l13.11-27.981L81.479,601.749l-13.1,27.976Zm-.616-22.985-4.361,9.31L82.1,624.73l4.348-9.329Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3385"
                data-name="Path 3385"
                d="M64.449,832.223h0l56.8-121.2-.015-.007L-.172,654.676h0l-55.818,119.17,1.088,2.988L64.449,832.224ZM35.215,773.264l-8.708,18.665,28,12.99,17.459-37.3-84.045-38.985-17.467,37.279L-1.522,778.9,7.22,760.279l-9.356-4.342-4.347,9.329-9.356-4.341L-7.1,742.292l28.031,13L3.45,792.557-43.244,770.9,4.8,668.329,51.49,690.01,34.034,727.319,6.011,714.3l8.734-18.64,9.341,4.323-4.372,9.329,9.349,4.345L37.788,695,9.776,682.011-7.7,719.292l84.042,39,4.379-9.333L93.84,721.006,65.813,708l-4.373,9.347-4.38,9.308,9.346,4.338,4.379-9.334,9.353,4.335-8.763,18.651-9.338-4.316-18.657-8.7,17.464-37.287,46.677,21.68L59.48,818.571l-46.7-21.647,17.464-37.311L58.29,772.6l-8.748,18.67-9.347-4.32,4.37-9.355Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3386"
                data-name="Path 3386"
                d="M64.449,832.224h0Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3387"
                data-name="Path 3387"
                d="M-114.556,612.94l4.961,13.631,82.032,38.087L-65.93,746.541l4.969,13.652,47.1-100.523Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3388"
                data-name="Path 3388"
                d="M-104.618,640.245l4.971,13.659,44.679,20.728-20.9,44.6,4.961,13.631,29.643-63.216Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3389"
                data-name="Path 3389"
                d="M-94.678,667.557l4.971,13.658,7.3,3.4-3.414,7.284,4.977,13.675,12.161-25.955Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3390"
                data-name="Path 3390"
                d="M207.737,463.385l-4.861,1.77,18.209,8.457L173.043,576.157l-46.7-21.647L143.808,517.2l28.045,12.984-8.748,18.67-9.348-4.321,4.371-9.353-9.35-4.328-8.709,18.664,28.005,12.99,17.459-37.3L120.62,495.093,106.9,500.085l27.588,12.79-17.48,37.267L70.318,528.486,78.835,510.3l-13.7,4.986-8.517,18.185.014.007,121.381,56.33h0L233.4,471.625A22.411,22.411,0,0,0,207.737,463.385Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3391"
                data-name="Path 3391"
                d="M194.286,506.548,207.4,478.591l-18.217-8.454-14.392,5.238-4.17,8.864,9.346,4.337,4.378-9.333,9.353,4.335-8.763,18.651-9.338-4.316-18.658-8.7,4.148-8.855L134.347,490.1l55.56,25.784Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3392"
                data-name="Path 3392"
                d="M112.04,536.483l8.742-18.618-9.356-4.341-4.347,9.329-9.355-4.342,8.527-18.189-13.709,4.99L84.022,523.5Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3393"
                data-name="Path 3393"
                d="M178.013,589.81h0Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3394"
                data-name="Path 3394"
                d="M-66.144,601.35l8.742-18.618-9.356-4.342L-71.1,587.72l-9.356-4.342,8.535-18.2-13.71,4.99-8.528,18.2Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3395"
                data-name="Path 3395"
                d="M-.173,654.676h0l56.8-121.2-.014-.007L38.4,525.019l-13.723,4.995L42.9,538.479-5.142,641.024l-46.7-21.647,17.464-37.311L-6.332,595.05l-8.747,18.67-9.348-4.32,4.37-9.355-9.35-4.327-8.708,18.664,28.005,12.99,17.458-37.3-64.929-30.118-13.713,4.991,27.6,12.8-17.48,37.268-46.694-21.658,8.524-18.2-4.788,1.743a22.412,22.412,0,0,0-14.363,22.871l118.32,54.91Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3396"
                data-name="Path 3396"
                d="M16.1,571.415l13.117-27.957L10.986,535l-14.37,5.23-4.178,8.879,9.346,4.337,4.379-9.333,9.353,4.335L6.753,567.1l-9.338-4.316-18.657-8.7,4.155-8.871-26.767,9.742,55.576,25.791Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3397"
                data-name="Path 3397"
                d="M-.173,654.677h0Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3398"
                data-name="Path 3398"
                d="M14.688,968.035l4.961,13.631,82.032,38.087-38.366,81.884,4.969,13.652,47.1-100.523Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3399"
                data-name="Path 3399"
                d="M24.626,995.34,29.6,1009l44.678,20.728-20.9,44.6,4.961,13.631,29.643-63.216Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3400"
                data-name="Path 3400"
                d="M34.566,1022.652l4.971,13.658,7.3,3.4L43.427,1047l4.977,13.675,12.161-25.955Z"
                fill={fillColor || '#8ea5ab'}
              />
            </g>
            <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#Path_3401)">
              <path
                id="Path_3401-2"
                data-name="Path 3401"
                d="M-17.121,501.048c-5.263-29.85,14.944-58.6,54.253-61.925l326.84-57.631c20.612-7.236,49.431,12.865,54.7,42.715l95.7,542.739a55.376,55.376,0,0,1-44.9,63.879l-326.841,57.63a55.374,55.374,0,0,1-64.043-44.668Z"
                fill="#fff"
              />
            </g>
            <g id="Group_295" data-name="Group 295">
              <path
                id="Path_3402"
                data-name="Path 3402"
                d="M387.845,979.48l-.04.057.057.04Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3403"
                data-name="Path 3403"
                d="M366.152,856.454h0l-.04.057.057.04Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3404"
                data-name="Path 3404"
                d="M372.828,894.314l-.04.057.057.04Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3405"
                data-name="Path 3405"
                d="M394.521,1017.34l-.04.057.057.04Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3406"
                data-name="Path 3406"
                d="M344.459,733.429h0l-.04.057.057.04Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3407"
                data-name="Path 3407"
                d="M351.135,771.289l-.04.057.057.04Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3408"
                data-name="Path 3408"
                d="M322.767,610.4h0l-.04.058.057.04Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3409"
                data-name="Path 3409"
                d="M329.442,648.263l-.04.057.057.04Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3410"
                data-name="Path 3410"
                d="M447.442,778.527l-2.523-14.307L370.7,712.445l52.033-74.058L420.213,624.1l-63.882,90.877Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3411"
                data-name="Path 3411"
                d="M442.391,749.881,439.873,735.6,399.42,707.381l28.363-40.348-2.524-14.315-40.2,57.2Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3412"
                data-name="Path 3412"
                d="M437.35,721.288l-2.527-14.332-6.651-4.644,4.658-6.656-2.524-14.314-16.518,23.506Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3413"
                data-name="Path 3413"
                d="M341.948,717.517h0l-76.959,109.51.014.01,109.755,76.552L450.5,795.866l-.531-3.008L341.948,717.516ZM360.5,780.68l11.834-16.863L347,746.163l-23.683,33.681,75.993,53,5.933-8.43,17.773-25.255-25.343-17.676-5.93,8.446-5.929,8.406,8.45,5.894,5.933-8.43,8.458,5.892L396.786,818.54l-8.446-5.871-16.865-11.8,23.674-33.687,42.2,29.456-65.119,92.645L330,859.852l23.678-33.712L379.045,843.8l-11.856,16.868-8.456-5.879,5.929-8.452-8.457-5.887-11.818,16.869,25.324,17.656,23.672-33.7-76-52.987-23.674,33.68,25.338,17.653L330.89,822.8l-8.46-5.9-5.9,8.433-8.459-5.9L319.908,802.6l25.351,17.668L321.573,853.93l-42.225-29.436,65.123-92.67,42.22,29.461-23.67,33.71L337.685,777.31l11.837-16.84,8.447,5.88-5.924,8.428Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3414"
                data-name="Path 3414"
                d="M480.252,964.6l-2.523-14.308-74.22-51.774,52.033-74.059-2.519-14.285-63.881,90.877Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3415"
                data-name="Path 3415"
                d="M475.2,935.954l-2.519-14.285-40.453-28.215,28.363-40.348-2.524-14.316-40.2,57.2Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3416"
                data-name="Path 3416"
                d="M470.159,907.359l-2.527-14.331-6.651-4.644,4.658-6.656-2.524-14.314L446.6,890.92Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3417"
                data-name="Path 3417"
                d="M262.475,812.7,327.6,720.058l-92.885-64.786-65.126,92.646Zm50.765-90.115L259.952,798.4l-75.995-53.012,53.277-75.828Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3418"
                data-name="Path 3418"
                d="M257.424,784.058l41.456-58.937-59.119-41.233-41.443,58.965Zm27.1-56.4L254.9,769.773l-42.227-29.451L242.285,698.2Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3419"
                data-name="Path 3419"
                d="M252.382,755.466l17.769-25.279-25.343-17.676-17.761,25.276Zm3.385-22.743-5.912,8.411-8.425-5.883,5.9-8.432Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3420"
                data-name="Path 3420"
                d="M430.481,967.558,424.551,976l-5.929,8.406,8.451,5.895,5.933-8.431,8.458,5.893-11.6,16.464,14.376-2.535,11.585-16.461Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3421"
                data-name="Path 3421"
                d="M326.519,1008.033l16.516,11.507,15.015-2.648,5.65-8.023-8.46-5.9-5.9,8.433-8.459-5.9,11.838-16.833,25.35,17.668-5.643,8.021,28.052-4.946-50.283-35.057Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3422"
                data-name="Path 3422"
                d="M297.8,1013.1l.014.01,16.487,11.5,14.367-2.533-16.508-11.508L377.28,917.9l42.22,29.461-23.669,33.71-25.337-17.685,11.837-16.84,8.448,5.879-5.925,8.429,8.452,5.9,11.834-16.864-25.332-17.654-23.682,33.681,58.727,40.961,14.359-2.532-8.063-5.6-16.864-11.8,23.673-33.687,42.2,29.456-11.568,16.458,5.127-.9a22.413,22.413,0,0,0,18.111-19.991L374.757,903.588Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3423"
                data-name="Path 3423"
                d="M265,827.036l-.014-.01-109.782-76.57h0L79.542,858.123l.552,3.132,107.921,75.272Zm-95.539,46.352-11.817,16.868,25.324,17.655,23.67-33.7-76-52.986L106.967,854.9l25.34,17.654,11.841-16.818-8.459-5.9-5.9,8.433-8.46-5.9,11.839-16.833,25.349,17.668L134.831,886.87,92.607,857.434l65.122-92.67,42.22,29.461-23.67,33.71-25.337-17.684,11.838-16.84,8.448,5.879-5.925,8.428,8.452,5.9,11.833-16.863L160.257,779.1l-23.683,33.682,75.993,53,5.933-8.43L236.272,832.1,210.93,814.426,205,822.872l-5.93,8.4,8.451,5.9,5.934-8.431,8.458,5.893L210.044,851.48l-8.447-5.872-16.863-11.8,23.673-33.687,42.2,29.455L185.492,922.22l-42.229-29.428L166.94,859.08,192.3,876.736,180.447,893.6l-8.456-5.878,5.929-8.453Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3424"
                data-name="Path 3424"
                d="M295.285,998.776l65.125-92.647-92.885-64.785L202.4,933.991Zm50.765-90.115-53.288,75.807-75.995-53.011,53.277-75.828Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3425"
                data-name="Path 3425"
                d="M290.233,970.13l41.456-58.937L272.571,869.96l-41.444,58.965Zm27.1-56.405-29.614,42.12-42.227-29.452L275.1,884.275Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3426"
                data-name="Path 3426"
                d="M285.192,941.537l17.769-25.278-25.343-17.676-17.762,25.276Zm3.384-22.742-5.911,8.411-8.425-5.883,5.9-8.432Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3427"
                data-name="Path 3427"
                d="M49.807,689.492l2.519,14.285L126.5,755.529l-52,73.978,2.523,14.307L140.859,753Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3428"
                data-name="Path 3428"
                d="M54.853,718.107l2.524,14.315,40.4,28.172L69.449,800.884l2.519,14.285,40.169-57.108Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3429"
                data-name="Path 3429"
                d="M59.9,746.73l2.524,14.314,6.6,4.62L64.4,772.244l2.527,14.332,16.483-23.449Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3430"
                data-name="Path 3430"
                d="M297.8,1013.1,188.015,936.527,113,1043.264a22.414,22.414,0,0,0,23.875,12.627l5.03-.887-16.493-11.5,65.121-92.671,42.22,29.461-23.669,33.711-25.337-17.684,11.838-16.841,8.447,5.879-5.925,8.429,8.452,5.9L218.4,982.829l-25.33-17.655-23.683,33.682,58.713,40.951,14.36-2.532-8.05-5.594-16.864-11.8,23.674-33.687,42.2,29.456-11.559,16.444,14.387-2.537,11.564-16.445Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3431"
                data-name="Path 3431"
                d="M139.777,1040.974l16.5,11.5,15.039-2.652,5.64-8.008-8.46-5.9-5.9,8.433-8.46-5.9,11.839-16.833,25.349,17.668-5.634,8.007,28.029-4.942-50.269-35.048Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3432"
                data-name="Path 3432"
                d="M243.74,1000.5l-5.931,8.445-5.929,8.407,8.451,5.894,5.933-8.43,8.458,5.893-11.59,16.45,14.376-2.535,11.574-16.447Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3433"
                data-name="Path 3433"
                d="M414.633,592.456l-2.523-14.307-74.22-51.774,52.033-74.059L387.4,438.031l-63.881,90.877Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3434"
                data-name="Path 3434"
                d="M409.582,563.811l-2.519-14.285L366.61,521.31l28.363-40.348-2.524-14.316-40.2,57.2Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3435"
                data-name="Path 3435"
                d="M404.54,535.216l-2.527-14.332-6.651-4.644,4.658-6.656L397.5,495.27l-16.517,23.507Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3436"
                data-name="Path 3436"
                d="M309.138,531.445h0l-76.959,109.51.014.01,109.754,76.551h0L417.69,609.794l-.53-3.007L309.139,531.445Zm18.549,63.165,11.834-16.864L314.19,560.092l-23.683,33.681,75.993,53,5.932-8.43,17.774-25.255-25.343-17.676-5.93,8.445L353,612.267l8.451,5.894,5.933-8.43,8.458,5.892-11.869,16.846L355.53,626.6l-16.864-11.8,23.674-33.687,42.2,29.456-65.118,92.645L297.2,673.781l23.677-33.712,25.364,17.657-11.857,16.867-8.456-5.878,5.929-8.453-8.456-5.885-11.818,16.868L336.9,688.9l23.671-33.7-76-52.987L260.9,635.891l25.338,17.653,11.843-16.816-8.46-5.9-5.9,8.433-8.459-5.9L287.1,616.526l25.35,17.668-23.685,33.665-42.225-29.436,65.122-92.671,42.22,29.462-23.669,33.71-25.337-17.685,11.837-16.84,8.448,5.879-5.925,8.429Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3437"
                data-name="Path 3437"
                d="M341.948,717.516h0Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3438"
                data-name="Path 3438"
                d="M229.666,626.633l65.125-92.646L201.906,469.2,136.78,561.847Zm50.765-90.115-53.288,75.808-76-53.012,53.277-75.828Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3439"
                data-name="Path 3439"
                d="M224.615,597.987,266.07,539.05l-59.118-41.233-41.444,58.965Zm27.1-56.405L222.1,583.7,179.869,554.25l29.607-42.119Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3440"
                data-name="Path 3440"
                d="M219.573,569.4l17.769-25.279L212,526.44l-17.762,25.276Zm3.385-22.743-5.912,8.411-8.425-5.883,5.9-8.432Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3441"
                data-name="Path 3441"
                d="M155.206,750.456h0l76.987-109.491-.014-.01L122.4,564.385h0L46.732,672.052l.553,3.132,107.921,75.273Zm-18.552-63.14-11.817,16.869,25.324,17.655,23.67-33.7-76-52.987-23.675,33.68L99.5,686.484l11.842-16.817-8.46-5.9-5.9,8.433-8.459-5.9,11.839-16.833,25.349,17.667L102.021,700.8,59.8,671.363l65.122-92.67,42.219,29.46L143.47,641.864l-25.337-17.685,11.838-16.84,8.448,5.879-5.926,8.429,8.453,5.9,11.833-16.864-25.331-17.654-23.683,33.682,75.993,53,5.933-8.43,17.772-25.255-25.342-17.676L172.19,636.8l-5.929,8.406,8.451,5.9,5.933-8.431,8.458,5.893-11.868,16.846-8.447-5.872-16.864-11.8L175.6,614.046,217.8,643.5l-65.118,92.645-42.229-29.427,23.677-33.712,25.363,17.656-11.857,16.868-8.455-5.877,5.928-8.454Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3442"
                data-name="Path 3442"
                d="M155.206,750.457h0Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3443"
                data-name="Path 3443"
                d="M17,503.42l2.519,14.285,74.172,51.753-52,73.978,2.523,14.308,63.84-90.817Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3444"
                data-name="Path 3444"
                d="M22.044,532.036l2.524,14.315,40.4,28.172L36.64,614.813,39.158,629.1,79.328,571.99Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3445"
                data-name="Path 3445"
                d="M27.091,560.659l2.524,14.314,6.6,4.62-4.627,6.581L34.117,600.5,50.6,577.056Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3446"
                data-name="Path 3446"
                d="M360.365,412.1l-5.1.9,16.464,11.491-65.118,92.645L264.385,487.71,288.063,454l25.363,17.657L301.57,488.522l-8.456-5.878,5.929-8.453-8.456-5.885-11.818,16.867,25.324,17.657,23.671-33.7-58.7-40.925-14.373,2.534,24.948,17.387-23.686,33.665L213.73,452.352l11.545-16.429-14.359,2.532-11.546,16.43.013.008,109.755,76.552h0l75.073-106.77A22.413,22.413,0,0,0,360.365,412.1Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3447"
                data-name="Path 3447"
                d="M339.623,452.275,357.4,427.02l-16.473-11.489-15.083,2.66-5.646,8,8.451,5.895,5.933-8.431,8.458,5.893L331.167,446.4l-8.446-5.872-16.865-11.8,5.623-8-28.027,4.942,50.239,35.04Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3448"
                data-name="Path 3448"
                d="M253.429,467.473l11.843-16.817-8.46-5.9-5.9,8.432-8.459-5.9,11.556-16.431L239.64,433.39l-11.549,16.43Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3449"
                data-name="Path 3449"
                d="M309.139,531.445h0Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3450"
                data-name="Path 3450"
                d="M66.688,500.413,78.53,483.6l-8.459-5.9-5.9,8.432-8.46-5.9,11.567-16.445-14.368,2.534L41.348,482.759Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3451"
                data-name="Path 3451"
                d="M122.4,564.384h0l76.986-109.492-.013-.008L182.9,443.395l-14.382,2.536,16.477,11.5-65.118,92.645L77.644,520.65l23.678-33.712L126.685,504.6l-11.857,16.867-8.455-5.878,5.928-8.453-8.457-5.886L92.027,518.114l25.324,17.655,23.67-33.7L82.309,461.132l-14.372,2.534,24.96,17.4L69.212,514.729,26.988,485.291l11.555-16.442-5.018.885a22.414,22.414,0,0,0-18.117,20.029L122.4,564.385Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3452"
                data-name="Path 3452"
                d="M152.882,485.215l17.772-25.255-16.486-11.5-15.06,2.655-5.656,8.019,8.451,5.894,5.933-8.431,8.458,5.893-11.868,16.846-8.447-5.872-16.864-11.8,5.633-8.014L96.7,458.595l50.253,35.05Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3453"
                data-name="Path 3453"
                d="M122.4,564.385h0Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3454"
                data-name="Path 3454"
                d="M82.617,875.563l2.519,14.285L159.308,941.6l-52,73.978,2.523,14.307,63.84-90.817Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3455"
                data-name="Path 3455"
                d="M87.663,904.179l2.524,14.315,40.4,28.171-28.329,40.291,2.519,14.286,40.17-57.108Z"
                fill={fillColor || '#8ea5ab'}
              />
              <path
                id="Path_3456"
                data-name="Path 3456"
                d="M92.71,932.8l2.524,14.314,6.6,4.62-4.627,6.581,2.527,14.332L116.218,949.2Z"
                fill={fillColor || '#8ea5ab'}
              />
            </g>
          </g>
          <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#Path_3457)">
            <path
              id="Path_3457-2"
              data-name="Path 3457"
              d="M117.333,397.745c0-33.245,27.3-60.445,60.667-60.445H542c33.367,0,60.667,27.2,60.667,60.445v604.444c0,33.244-27.3,60.444-60.667,60.444H178c-33.367,0-60.667-27.2-60.667-60.444Z"
              fill="#fff"
            />
          </g>
          <path
            id="Path_3458"
            data-name="Path 3458"
            d="M178,359.966a37.933,37.933,0,0,0-38,37.779v604.444a37.932,37.932,0,0,0,38,37.777H542a37.932,37.932,0,0,0,38-37.777V397.745a37.933,37.933,0,0,0-38-37.779Z"
            fill="none"
            stroke="#d9000d"
            strokeMiterlimit="10"
            strokeWidth="2.667"
          />
          <path
            id="Path_3459"
            data-name="Path 3459"
            d="M263.814,986.559a23.65,23.65,0,0,1-45.189,9.763,23.649,23.649,0,0,1-45.188-9.763h0c0-.033-3.445-24.459,45.031-55.9l.13-.084.13.084c43.942,28.5,45.225,51.235,45.077,55.264C263.811,986.135,263.814,986.346,263.814,986.559Z"
            fill="#dc091d"
          />
          <path
            id="Path_3460"
            data-name="Path 3460"
            d="M456.186,413.375a23.65,23.65,0,0,1,45.189-9.763,23.649,23.649,0,0,1,45.188,9.763h0c.005.032,3.445,24.458-45.031,55.9l-.13.085-.13-.085c-43.942-28.5-45.225-51.235-45.077-55.263Q456.186,413.694,456.186,413.375Z"
            fill="#dc091d"
          />
        </g>
      </g>
    </svg>
  );
}

export default PaxCardGroup1;
